import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import Home from "../pages/home"
import Form from "../pages/form"
import PqrsfList from "../pages/pqrsfList"
import SearchPqr from "../pages/searchPqr"
import Layout from "../components/layout"

const LayoutRouter = () => {
  return (
    <Layout>
      <Router>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route
            exact
            path="/form/:document_type/:document_num"
            element={<Form />}
          />
          <Route exact path="/pqrsflist" element={<PqrsfList />} />
          <Route exact path="/searchpqrsf" element={<SearchPqr />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Router>
    </Layout>
  )
}

export default LayoutRouter
